<template>
  <div class="container bottom">
    <div class="header bottom-shadow">
      <label>Route Password</label>
    </div>

    <div class="mid-container">
      <div class="input-container">
        <label>Password (Optional):</label>
        <input v-model="privateId.id" type="text" name="password" placeholder="Your password"></input>
        <p class="description">This password is only used to access this event in the Peps app. The password is also mailed to you when you're done.</p>
      </div>
    </div>

  <BottomNav @previousPage="previousPage()" @nextPage="nextPage()" pText="Back" pColor="blue" nText="Done!" nColor="green" />

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.js'
//import Vue from 'vue'
import BottomNav from './BottomNav'
import { userRef } from '../firebase'
import firebase from 'firebase'
import { store } from '../store/store'
import { mapGetters } from 'vuex'

import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'getInfoField',
  mutationType: 'updateInfoField',
});

export default {
  name: 'eventKey',
  title: 'Runner - Event Key',
    computed: {
      ...mapFields(['privateId']),
    },
  components: {
    BottomNav
  },
  mounted() {
    console.log("mounted")
    console.log(this.privateId)

    if(this.privateId.initialized == false) {
      console.log("initialized was false")
      this.$store.dispatch('initPrivateId')
    } else {
      console.log("initialized was true")
    }
  },
  methods: {
    nextPage() {
      this.submitKey()
    },
    previousPage() {
      this.$router.replace('information')
    },
    submitKey() {
      const key = this.privateId.id || Math.random().toString(36).substring(2, 15)
      this.$store.dispatch('submitEventKey', key).then(() => {
        this.$router.replace('done')
      })
    },
  }

}
</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .mid-container {
    padding: 10%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    flex: 9;

    p {
      line-height: 1.4;
    }

  }

  .description {
    text-align: center;
  }

  .error {
    border: 2px solid red;
    outline: none;
  }

  @media screen and (min-width: 1140px) {
    .container.bottom {
      width: 600px;
      height: 360px;
    }

    .mid-container {
      padding: 1% 15% 1%;
      justify-content: center;
    }
  }

</style>
